<div class="navigation__burgermenu d-flex d-lg-none" (click)="toggleNavigation()" [ngClass]="isBurgermenuOpen ? 'navigation__burgermenu--checked' : ''" [attr.data-testid]="'burgermenu'">
    <span class="navigation__label">
        <span class="navigation__icon d-inline-block"></span>
    </span>
</div>